/**
 * Created by robert.lavoie on 6/15/17.
 */

import { Component, Input } from '@angular/core';

// Models
import { SiteColumn } from '../../models';

/**
 *
 * @class
 * ColumnImageComponent
 *
 * @description
 * This component displays an image within a column
 *
 */
@Component({
  templateUrl: 'customer-site-column-image.component.html',
  selector: 'customer-site-column-image',
  styleUrls: ['./customer-site-column-image.component.scss'],
})
export class CustomerSiteColumnImageComponent{

    // The current column
  @Input() column: SiteColumn;

  constructor() {}

}